import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { RouletteScene } from "./RouletteScene";

export class UpperContainer extends Phaser.GameObjects.Container {

    private spinsCounter: Phaser.GameObjects.Text;
    private availableSpinsContainer: Phaser.GameObjects.Container;
    private getSpinsButton: Phaser.GameObjects.Image;
    private gameTitle: Phaser.GameObjects.Image;
    private playAgainButton: Phaser.GameObjects.Image;
    private goToCouponsButton: Phaser.GameObjects.Image;

    private container1: Phaser.GameObjects.Container;
    private container2: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene) {
        
        super(scene);        

        this.container1 = new Phaser.GameObjects.Container(this.scene);
        this.container1.x = GameConstants.GAME_WIDTH / 2;
        this.add(this.container1);

        let buttons_px: number;

        if (GameVars.aspectRatio < 1.65) {

            this.container1.y = 120;
            this.container1.scaleX = .75;
            this.container1.scaleY = .75 * GameVars.scaleY;

            buttons_px = 510;
  
        } else {

            this.container1.y = 140;
            this.container1.scaleY = GameVars.scaleY;

            buttons_px = 260;
        }

        this.gameTitle = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "game_title");
        this.container1.add(this.gameTitle);

        this.availableSpinsContainer = new Phaser.GameObjects.Container(this.scene, -buttons_px, 150);
        this.container1.add(this.availableSpinsContainer);

        const availableSpins = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "available_spins");
        this.availableSpinsContainer.add(availableSpins); 

        let fontSize: string;
        let py: number;

        if (GameVars.spinsCounter < 10) {
            fontSize = "112px";
            py = 60;
        } else if(GameVars.spinsCounter < 100) {
            fontSize = "70px";
            py = 40;
        } else {
            fontSize = "48px";
            py = 25;
        }

        this.spinsCounter = new Phaser.GameObjects.Text(this.scene, 132, py, GameVars.spinsCounter.toString(), {fontFamily: "FuturaPTDemi", fontSize: fontSize, color: "#F2CC4F"});
        this.spinsCounter.setOrigin(.5, 1);
        this.availableSpinsContainer.add(this.spinsCounter);

        this.getSpinsButton = new Phaser.GameObjects.Image(this.scene, -buttons_px, 150, "texture_atlas_1", "btn_get_spin");
        this.getSpinsButton.setInteractive();
        this.getSpinsButton.on("pointerover", () => {
            this.getSpinsButton.setScale(1.05);
        }, this);

        this.getSpinsButton.on("pointerout", () => {
            this.getSpinsButton.setScale(1);
        }, this);

        this.getSpinsButton.on("pointerdown", () => {
            this.getSpinsButton.setScale(1.05);
        }, this);

        this.getSpinsButton.on("pointerup", () => {
            this.getSpinsButton.setScale(1);
            this.onGetSpinsButtonClick();
        }, this);

        this.getSpinsButton.visible = false;
        this.container1.add(this.getSpinsButton);

        const myPresentButton = new Phaser.GameObjects.Image(this.scene, buttons_px, 150, "texture_atlas_1", "btn_presents");
        myPresentButton.setInteractive();
        myPresentButton.on("pointerover", () => {
            myPresentButton.setScale(1.05);
        }, this);

        myPresentButton.on("pointerout", () => {
            myPresentButton.setScale(1);
        }, this);

        myPresentButton.on("pointerdown", () => {
            myPresentButton.setScale(1.05);
        }, this);

        myPresentButton.on("pointerup", () => {
            myPresentButton.setScale(1);
            this.onMyPresentButtonClick();
        }, this);

        this.container1.add(myPresentButton);

        if(GameVars.spinsCounter === 0) {
            this.availableSpinsContainer.visible = false;
            this.getSpinsButton.visible = true;
        }

        // LOS ITEMS Q SALEN AL MOSTRAR EL PREMIO
        this.container2 = new Phaser.GameObjects.Container(this.scene);
        this.container2.visible = false;
        this.add(this.container2);

        this.container2.x = GameConstants.GAME_WIDTH / 2;

        if (GameVars.aspectRatio < 1.65) {

            this.container2.y = 120;
            this.container2.scaleX = .75;
            this.container2.scaleY = .75 * GameVars.scaleY;

            buttons_px = 260;
            
        } else {

            this.container2.y = 140;
            this.container2.scaleY = GameVars.scaleY;
        }

        const title = new Phaser.GameObjects.Text(this.scene, 0, 0, "УРА, ВЫ ВЫИГРАЛИ", { fontFamily: "FuturaPTBold", fontSize: "62px", color: "#FFC24B"});
        title.setOrigin(.5)
        this.container2.add(title);

        this.playAgainButton = new Phaser.GameObjects.Image(this.scene, -buttons_px, 225, "texture_atlas_1", "btn_play_again");
        this.playAgainButton.setInteractive();
        this.playAgainButton.on("pointerover", () => {
            this.playAgainButton.setScale(1.05);
        }, this);

        this.playAgainButton.on("pointerout", () => {
            this.playAgainButton.setScale(1);
        }, this);

        this.playAgainButton.on("pointerdown", () => {
            this.playAgainButton.setScale(1.05);
        }, this);

        this.playAgainButton.on("pointerup", () => {
            this.playAgainButton.setScale(1);
            GameManager.enterRouletteScene();
            this.scene.sound.playAudioSprite("audio-sprite", "click_btn");
        }, this);
        this.container2.add( this.playAgainButton);
        
        this.goToCouponsButton = new Phaser.GameObjects.Image(this.scene, buttons_px, 225, "texture_atlas_1", "btn_go_to_coupons");
        this.goToCouponsButton.setInteractive();
        this.goToCouponsButton.on("pointerover", () => {
            this.goToCouponsButton.setScale(1.05);
        }, this);

        this.goToCouponsButton.on("pointerout", () => {
            this.goToCouponsButton.setScale(1);
        }, this);

        this.goToCouponsButton.on("pointerdown", () => {
        this.goToCouponsButton.setScale(1.05);
        }, this);

        this.goToCouponsButton.on("pointerup", () => {
            this.goToCouponsButton.setScale(1);
            GameManager.openDeepLink(GameVars.spinResponse.prize.deeplink);
            this.scene.sound.playAudioSprite("audio-sprite", "click_btn");
        }, this);
        this.container2.add(this.goToCouponsButton);
    }

    public onSpin(): void {

        const availableSpins = parseInt(this.spinsCounter.text) - 1;
        this.spinsCounter.text = availableSpins.toString();

        let fontSize: number;
        let py: number;

        if (availableSpins < 10) {
            fontSize = 112;
            py = 60;
        } else if (availableSpins < 100) {
            fontSize = 70;
            py = 40;
        } else {
            fontSize = 48;
            py = 25;
        }

        this.spinsCounter.y = py;
        this.spinsCounter.setFontSize(fontSize);

        this.spinsCounter.scaleY = .8;

        this.scene.add.tween({
            targets: this.spinsCounter,
            scaleY: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 150
        });

    }

    public onPrizeShown(): void {

        this.scene.add.tween({
            targets: this.container1,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350,
            onComplete: function(): void{
                this.container1.visible = false;
            },
            onCompleteScope: this
        });

        this.container2.alpha = 0;
        this.container2.visible = true;

        this.scene.add.tween({
            targets: this.container2,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350,
            delay: 350
        });

        this.spinsCounter.text = GameVars.spinsCounter.toString();

        if (GameVars.spinsCounter === 0) {
            this.playAgainButton.visible = false;
            this.goToCouponsButton.x = 0;
        } 

        if ((GameVars.spinResponse.prize.is_complex === 1 && GameVars.spinResponse.prize.is_full_complex === 0) || GameVars.spinResponse.prize.is_won === 1) {
            this.goToCouponsButton.visible = false;
            this.playAgainButton.x = 0;
        }
    }

    private onGetSpinsButtonClick(): void {

        GameManager.enterInfoScene();

        this.scene.sound.playAudioSprite("audio-sprite", "click_btn");
    }

    private onMyPresentButtonClick(): void {


        GameManager.openDeepLink(GameVars.gameInfo.first_screen.my_prizes_deeplink);

        this.scene.sound.playAudioSprite("audio-sprite", "click_btn");
    }
}
